/**
 * Hagatna Admin — Image URL Resolution
 */

// Uploaded media is served from the API origin under /uploads — the API base minus the /api/v1 path.
const ASSETS_ORIGIN = (import.meta.env.VITE_API_URL || '').replace(/\/api\/v1\/?$/, '')

/**
 * Resolve an image URL coming from the backend.
 * Uploads are stored as relative paths ("/uploads/products/x.webp") which would
 * otherwise resolve against the admin panel's own origin and 404.
 */
export function imgUrl(url) {
  if (!url) return ''
  if (url.startsWith('/uploads')) return `${ASSETS_ORIGIN}${url}`
  return url
}
